/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */
import { type StoreActionApi } from 'react-sweet-state';

import { getRovoParams, updatePageRovoParams } from '@atlaskit/rovo-triggers/params';
import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import { type ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { StoreErrorFlagId } from '../../common/ui/hooks/use-show-store-error-flag/StoreErrorFlagId';

import { removeConversationFromStore } from './removeConversationFromStore';
import { setSelectedConversation } from './setSelectedConversation';
import type { ChatStoreContainerProps } from './types';

export const handleForbiddenConversation = ({
	conversationId,
	dispatch,
	sendAnalyticsEvent,
	showFlag,
}: {
	conversationId: string;
	dispatch: StoreActionApi<ChatStorePrivateState>['dispatch'];
	sendAnalyticsEvent: ChatStoreContainerProps['sendAnalyticsEvent'];
	showFlag?: ChatStoreContainerProps['showFlag'];
}): void => {
	const rovoParams = getRovoParams();
	const isConversationIdInRovoParams = !!rovoParams?.conversationId;

	sendAnalyticsEvent({
		eventType: 'track',
		action: 'forbidden',
		actionSubject: 'rovoChatFetchConversation',
		attributes: {
			isConversationIdInRovoParams,
		},
	});

	dispatch(removeConversationFromStore({ conversationId }));
	dispatch(setSelectedConversation({ conversationId: EMPTY_CONVERSATION_ID }));

	if (isConversationIdInRovoParams) {
		updatePageRovoParams({
			conversationId: undefined,
		});
	}

	showFlag?.(StoreErrorFlagId.CONVERSATION_FORBIDDEN);
};
